import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TagDTO } from "@core/models";
import { getTagChipClassName } from "@shared/utils/tag-chip-style.util";

@Component({
  selector: "app-driveb-tag-chip",
  templateUrl: "./tag-chip.component.html",
  styleUrls: ["./tag-chip.component.scss"],
  standalone: false
})
export class TagChipComponent {
  @Input() tag: TagDTO;
  @Input() removable = true;
  @Output() remove = new EventEmitter<TagDTO>();

  get tagClassName(): string {
    return getTagChipClassName(this.tag?.tagType);
  }

  onRemoveTag(event: MouseEvent): void {
    event.stopPropagation();
    this.remove.emit(this.tag);
  }
}
